module.exports = __webpack_public_path__ + "img/check.93b9bea8.svg";